export const RELEASE_NOTES_PATH = '/release-notes';
